import { createSelector } from 'reselect';

import { DonationCreditRuleState } from 'entities/donationCreditRule/reducer';
import { State } from 'reducers';

export const selectDonationCreditRulesState = (state: State): DonationCreditRuleState =>
  state.get('entities').donationCreditRule;

export const selectDonationCreditRules = createSelector(
  selectDonationCreditRulesState,
  (donationCreditRules) => donationCreditRules
);

export const selectActiveDonationCreditRules = createSelector(
  selectDonationCreditRules,
  (donationCreditRules) => donationCreditRules.filter((rule) => !!rule?.isActive)
);

export const selectDonationCreditRuleById = createSelector(
  selectDonationCreditRules,
  (_state, donationCreditRuleId: string) => donationCreditRuleId,
  (donationCreditRules, donationCreditRuleId) => donationCreditRules.get(donationCreditRuleId)
);
